module.exports = __webpack_public_path__ + "img/Halle_Leer 004.85618012.jpg";